"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rotateOut = exports.rotateIn = void 0; // -------------------------------------------
//   ANIMATIONS > ROTATE
// -------------------------------------------
// (((((((((( ~~~~~~~~~~ ROTATE : IN ~~~~~~~~~~ )))))))))) //

var rotateIn = {
  // ***** ROTATE : IN ***** //
  '@keyframes rotateIn': {
    from: {
      transformOrigin: 'center',
      opacity: '0',
      transform: 'rotate3d(0, 0, 1, -200deg)'
    },
    to: {
      transformOrigin: 'center',
      opacity: '1',
      transform: 'none'
    }
  },
  // ***** ROTATE : IN : DOWN : LEFT ***** //
  '@keyframes rotateInDownLeft': {
    from: {
      transformOrigin: 'left bottom',
      opacity: '0',
      transform: 'rotate3d(0, 0, 1, -45deg)'
    },
    to: {
      transformOrigin: 'left bottom',
      opacity: '1',
      transform: 'none'
    }
  },
  // ***** ROTATE : IN : DOWN : RIGHT ***** //
  '@keyframes rotateInDownRight': {
    from: {
      transformOrigin: 'right bottom',
      opacity: '0',
      transform: 'rotate3d(0, 0, 1, 45deg)'
    },
    to: {
      transformOrigin: 'right bottom',
      opacity: '1',
      transform: 'none'
    }
  },
  // ***** ROTATE : IN : UP : LEFT ***** //
  '@keyframes rotateInUpLeft': {
    from: {
      transformOrigin: 'left bottom',
      opacity: '0',
      transform: 'rotate3d(0, 0, 1, 45deg)'
    },
    to: {
      transformOrigin: 'left bottom',
      opacity: '1',
      transform: 'none'
    }
  },
  // ***** ROTATE : IN : UP : RIGHT ***** //
  '@keyframes rotateInUpRight': {
    from: {
      transformOrigin: 'right bottom',
      opacity: '0',
      transform: 'rotate3d(0, 0, 1, -90deg)'
    },
    to: {
      transformOrigin: 'right bottom',
      opacity: '1',
      transform: 'none'
    }
  }
}; // (((((((((( ~~~~~~~~~~ ROTATE : OUT ~~~~~~~~~~ )))))))))) //

exports.rotateIn = rotateIn;
var rotateOut = {
  // ***** ROTATE : OUT ***** //
  '@keyframes rotateOut': {
    from: {
      transformOrigin: 'center',
      opacity: '1',
      transform: 'rotate3d(0, 0, 1, 200deg)'
    },
    to: {
      transformOrigin: 'center',
      opacity: '0',
      transform: 'none'
    }
  },
  // ***** ROTATE : OUT : DOWN : LEFT ***** //
  '@keyframes rotateOutDownLeft': {
    from: {
      transformOrigin: 'left bottom',
      opacity: '1',
      transform: 'rotate3d(0, 0, 1, 45deg)'
    },
    to: {
      transformOrigin: 'left bottom',
      opacity: '0',
      transform: 'none'
    }
  },
  // ***** ROTATE : OUT : DOWN : RIGHT ***** //
  '@keyframes rotateOutDownRight': {
    from: {
      transformOrigin: 'right bottom',
      opacity: '1',
      transform: 'rotate3d(0, 0, 1, -45deg)'
    },
    to: {
      transformOrigin: 'right bottom',
      opacity: '0',
      transform: 'none'
    }
  },
  // ***** ROTATE : OUT : UP : LEFT ***** //
  '@keyframes rotateOutUpLeft': {
    from: {
      transformOrigin: 'left bottom',
      opacity: '1',
      transform: 'rotate3d(0, 0, 1, -45deg)'
    },
    to: {
      transformOrigin: 'left bottom',
      opacity: '0',
      transform: 'none'
    }
  },
  // ***** ROTATE : OUT : UP : RIGHT ***** //
  '@keyframes rotateOutUpRight': {
    from: {
      transformOrigin: 'right bottom',
      opacity: '1',
      transform: 'rotate3d(0, 0, 1, 90deg)'
    },
    to: {
      transformOrigin: 'right bottom',
      opacity: '0',
      transform: 'none'
    }
  }
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.rotateOut = rotateOut;